module.exports = TipTap.Link;


//////////////////
// WEBPACK FOOTER
// external "TipTap.Link"
// module id = 482
// module chunks = 0 1